module.exports = __webpack_public_path__ + "static/media/ribbon.2f42bd04.svg";